import { render, staticRenderFns } from "./ServicoExtra.vue?vue&type=template&id=47a53bc3&lang=pug&"
import script from "./ServicoExtra.vue?vue&type=script&lang=js&"
export * from "./ServicoExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports